export default {
  apiServerUrl: 'https://wedlinycrm.devsafi.pl'
};